import React from 'react';
import { Smartphone, Cloud, Shield } from 'react-feather';

const Download = () => {
  return (
    <div className="download-page">
      <section className="download-hero">
        <div className="container">
          <h1 className="section-title">download <span className="text-gradient">pplkpr</span></h1>
          <p className="download-subtitle">
            Get started with building deeper connections today. Available on iOS and Android.
          </p>
          <div className="cta-buttons download-cta">
            <a href="https://apps.apple.com/us/app/pplkpr/id6498893335" className="btn btn-primary" target="_blank" rel="noopener noreferrer">
              <Smartphone size={16} /> download for iOS
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.sickstrat.pplkpr" className="btn btn-primary" target="_blank" rel="noopener noreferrer">
              <Smartphone size={16} /> download for Android
            </a>
          </div>
        </div>
      </section>

      <section className="download-features">
        <div className="container">
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <Smartphone size={28} />
              </div>
              <h3>iOS & Android</h3>
              <p>Native apps for both iOS and Android, optimized for the best mobile experience.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <Cloud size={28} />
              </div>
              <h3>cloud sync</h3>
              <p>Your data syncs securely across all your devices, so your relationships stay up to date everywhere.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <Shield size={28} />
              </div>
              <h3>secure & private</h3>
              <p>Your relationship data is encrypted and secure. We never share your personal information.</p>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Download;
